export const gitHash = 'a4380f9/0c3f924';
